export const cmsElementTypes = {
  CARD: 'card',
  LOCATION: 'location',
  TEXT: 'text',
};

export const cmsStyles = {
  HEADING: 'heading',
  SMALL: 'small',
  SUBTEXT: 'subtext',
  ULTRAWIDEBOLD: 'ultrawide-bold',
};

export const thirdColumnMenu = [
  {
    id: 'cmsmenu-morefromheading',
    name: 'More from <span style="white-space:nowrap">Waitrose &amp; Partners</span>',
    style: 'heading',
  },
  {
    id: 'cmsmenu-asidenewtab',
    name: 'Each website opens in a new tab/window',
    style: 'small',
  },
  {
    card: true,
    href: 'https://www.waitrosecellar.com/?utm_source=waitrose.com&utm_medium=referral&utm_campaign=megamenu_cellar',
    id: 'cmsmenu-cellar-title',
    name: 'CELLAR',
    newWindow: true,
    style: 'ultrawide-bold',
    subtext: 'Our shop dedicated to wine, fizz and spirits',
  },
  {
    card: true,
    href: 'https://dishpatch.co.uk/?utm_source=waitrose.com&utm_medium=referral&utm_campaign=megamenu_dishpatch',
    id: 'cmsmenu-dishpatchn-title',
    name: 'DISHPATCH',
    newWindow: true,
    style: 'ultrawide-bold',
    subtext: 'Chef-created set menus, by restaurant-quality meal delivery experts Dishpatch.',
  },
];
